// extracted by mini-css-extract-plugin
export default {"container":"Search_container__KUBz6","select":"Search_select__9iZxR"};